import http from '@/services/http';

import events from '@/services/events';

// TODO: write tests
async function addUpsellItemsToOrder({ rootState, rootGetters, dispatch }, upsellItems) {
  const { order } = rootState.orders;

  const orderTypeQueryParams = rootGetters['orders/orderTypeQueryParams'];

  try {
    const requestParams = { params: orderTypeQueryParams };

    const orderResponse = await http.post(`/cardfree-api/v1/account/me/order/${order.orderId}/items`, upsellItems, requestParams);

    const updateOrderPayload = { order: orderResponse.data, validate: true };

    await dispatch('orders/updateOrderWithResponse', updateOrderPayload, { root: true });

    const eventPayload = { type: 'success', message: 'Items were added to your cart.' };

    events.emit('notification', eventPayload);
  }
  catch (error) {
    throw error;
  }
}

export { addUpsellItemsToOrder };
